export default __webpack_public_path__ + "static/media/friendsNcake.4393cd0f.jpeg";